import { render, staticRenderFns } from "./update-user-role-cost.vue?vue&type=template&id=5ce7526a&scoped=true"
import script from "./update-user-role-cost.vue?vue&type=script&lang=js"
export * from "./update-user-role-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7526a",
  null
  
)

export default component.exports